<div class="public-talk-page">
    <div class="form-container">
  
      <!-- HEADER -->
      <div class="form-header">
        <div class="header-icon">
          🎤
        </div>
  
        <h1>Formulario de plática</h1>
  
        <p>
          Completa la siguiente información para registrar una plática
          realizada con ABAQ.
        </p>
      </div>
  
      @if (submitted) {
  
        <!-- SUCCESS -->
        <div class="success-card">
  
          <div class="success-icon">
            ✓
          </div>
  
          <h2>¡Formulario enviado correctamente!</h2>
  
          <p>
            Hemos recibido la información de la plática.
            El equipo de ABAQ revisará los datos registrados.
          </p>
  
        </div>
  
      } @else {
  
        <form
          class="talk-form"
          (ngSubmit)="submitForm()"
        >
  
          <!-- INFORMACIÓN DE LA PLÁTICA -->
          <section class="form-section">
  
            <div class="section-header">
              <h2>Información de la plática</h2>
  
              <p>
                Proporciona los datos generales de la plática realizada.
              </p>
            </div>
  
            <div class="form-group">
              <label for="name">
                Nombre de la plática *
              </label>
  
              <input
                id="name"
                type="text"
                name="name"
                [(ngModel)]="name"
                placeholder="Nombre de la plática"
                required
              />
            </div>
  
            <div class="form-row">
  
              <div class="form-group">
                <label for="date">
                  Fecha *
                </label>
  
                <input
                  id="date"
                  type="date"
                  name="date"
                  [(ngModel)]="date"
                  required
                />
              </div>
  
              <div class="form-group">
                <label for="location">
                  Lugar *
                </label>
  
                <input
                  id="location"
                  type="text"
                  name="location"
                  [(ngModel)]="location"
                  placeholder="Lugar donde se realizó"
                  required
                />
              </div>
  
            </div>
  
          </section>
  
  
          <!-- PARTICIPANTES -->
          <section class="form-section">
  
            <div class="section-header participants-header">
  
              <div>
                <h2>Participantes</h2>
  
                <p>
                  Registra a las personas que participaron en la plática.
                </p>
              </div>
  
              <button
                type="button"
                class="add-participant-button"
                (click)="addParticipant()"
              >
                + Agregar participante
              </button>
  
            </div>
  
  
            @for (
              participant of participants;
              track $index;
              let i = $index
            ) {
  
              <div class="participant-card">
  
                <div class="participant-card-header">
  
                  <h3>
                    Participante {{ i + 1 }}
                  </h3>
  
                  @if (participants.length > 1) {
  
                    <button
                      type="button"
                      class="remove-participant-button"
                      (click)="removeParticipant(i)"
                    >
                      Eliminar
                    </button>
  
                  }
  
                </div>
  
  
                <div class="form-group">
                  <label [for]="'participant-name-' + i">
                    Nombre completo *
                  </label>
  
                  <input
                    [id]="'participant-name-' + i"
                    type="text"
                    [name]="'participantName' + i"
                    [(ngModel)]="participant.name"
                    placeholder="Nombre completo"
                    required
                  />
                </div>
  
  
                <div class="form-row">
  
                  <div class="form-group">
                    <label [for]="'participant-sex-' + i">
                      Sexo
                    </label>
  
                    <select
                      [id]="'participant-sex-' + i"
                      [name]="'participantSex' + i"
                      [(ngModel)]="participant.sex"
                    >
                      <option value="">
                        Selecciona una opción
                      </option>
  
                      <option value="F">
                        Femenino
                      </option>
  
                      <option value="M">
                        Masculino
                      </option>
                    </select>
                  </div>
  
  
                  <div class="form-group">
                    <label [for]="'participant-age-' + i">
                      Edad
                    </label>
  
                    <input
                      [id]="'participant-age-' + i"
                      type="number"
                      min="0"
                      [name]="'participantAge' + i"
                      [(ngModel)]="participant.age"
                      placeholder="Edad"
                    />
                  </div>
  
                </div>
  
  
                <div class="form-row">
  
                  <div class="form-group">
                    <label [for]="'participant-email-' + i">
                      Correo electrónico
                    </label>
  
                    <input
                      [id]="'participant-email-' + i"
                      type="email"
                      [name]="'participantEmail' + i"
                      [(ngModel)]="participant.email"
                      placeholder="correo@ejemplo.com"
                    />
                  </div>
  
  
                  <div class="form-group">
                    <label [for]="'participant-phone-' + i">
                      Teléfono
                    </label>
  
                    <input
                      [id]="'participant-phone-' + i"
                      type="tel"
                      [name]="'participantPhone' + i"
                      [(ngModel)]="participant.phone"
                      placeholder="Número de teléfono"
                    />
                  </div>
  
                </div>
  
  
                <div class="form-group">
                  <label [for]="'participant-follow-up-' + i">
                    Seguimiento
                  </label>
  
                  <textarea
                    [id]="'participant-follow-up-' + i"
                    [name]="'participantFollowUp' + i"
                    [(ngModel)]="participant.followUp"
                    rows="3"
                    placeholder="Agrega información de seguimiento..."
                  ></textarea>
                </div>
  
              </div>
  
            }
  
          </section>
  
  
          <!-- ENCUESTAS -->
          <section class="form-section">
  
            <div class="section-header">
              <h2>Encuestas</h2>
  
              <p>
                Indica si se realizaron las encuestas correspondientes.
              </p>
            </div>
  
  
            <label class="checkbox-row">
  
              <input
                type="checkbox"
                name="entrySurvey"
                [(ngModel)]="entrySurvey"
              />
  
              <span>
                Se realizó encuesta de entrada
              </span>
  
            </label>
  
  
            <label class="checkbox-row">
  
              <input
                type="checkbox"
                name="exitSurvey"
                [(ngModel)]="exitSurvey"
              />
  
              <span>
                Se realizó encuesta de salida
              </span>
  
            </label>
  
          </section>
  
  
          <!-- SUBMIT -->
          <div class="form-actions">
  
            <button
              type="submit"
              class="submit-button"
              [disabled]="
                !name ||
                !date ||
                !location ||
                isSubmitting
              "
            >
  
              @if (isSubmitting) {
                Enviando formulario...
              } @else {
                Enviar formulario
              }
  
            </button>
  
          </div>
  
        </form>
  
      }
  
    </div>
  </div>